/**
 * snuggle suds — scroll-triggered reveal
 * Adds a subtle fade-up animation as elements enter the viewport.
 * Honors prefers-reduced-motion.
 */
(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  // Respect reduced-motion preference — don't add the pending state at all.
  if (
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    return;
  }

  var selectors = [
    '.ss-cloud-hero-content > *',
    '.ss-formula-card',
    '.ss-formula-eyebrow',
    '.ss-formula-title',
    '.ss-coming-tile',
    '.ss-photo-strip-item',
    '.ss-founder-portrait',
    '.ss-founder-copy > *',
    '.ss-soft-place-inner > *',
    '.ss-community-inner > *',
    '.ss-newsletter-inner > *',
    '.ss-interlude-inner',
    '.ss-terms-card',
    '.ss-wholesale-hero-inner > *',
    '.ss-wholesale-pitch-inner > *',
    '.ss-ws-contact-inner > *',
    '.ss-retailers-inner > *'
  ];

  function init() {
    var elements = document.querySelectorAll(selectors.join(','));
    if (elements.length === 0) return;

    elements.forEach(function (el) {
      el.classList.add('ss-reveal-pending');
    });

    if (!('IntersectionObserver' in window)) {
      // No support — just show everything.
      elements.forEach(function (el) {
        el.classList.remove('ss-reveal-pending');
        el.classList.add('ss-reveal-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.remove('ss-reveal-pending');
            entry.target.classList.add('ss-reveal-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
